
    export default {
      name: "IconDiamond",
      props: {
        fill: {
          default: '#7987A1'
        },
        height: {
          default: '25',
        },
        width: {
          default: '25',
        }
      }
    }
  